import React from 'react';
import { Colors } from 'styles/constants';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';

export function DataHint({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: React.ReactElement;
}) {
  return (
    <TooltipProvider delayDuration={180} skipDelayDuration={80}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="top"
          sideOffset={9}
          collisionPadding={14}
          className="stay-data-tooltip"
          style={
            {
              '--stay-tooltip-background': Colors.Gray70,
            } as React.CSSProperties
          }
        >
          <strong>{title}</strong>
          <p>{description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function ColumnHint({
  label,
  description,
}: {
  label: string;
  description: string;
}) {
  return (
    <DataHint title={label} description={description}>
      <span className="stay-column-hint" tabIndex={0}>
        {label}
      </span>
    </DataHint>
  );
}
